var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{staticClass:"page-unauthorized",attrs:{"fluid":""}},[_c('h1',[_vm._v("Some error with authorization occurs")]),_c('p',[_vm._v("Please refresh the page to solve it OR select another page from the NAVBAR")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }